import {SCREEN_NAMES} from '/enum/tealium.enum';
import {withScreenPersistence} from '/util/async-storage';

import CandidateProfileConnected from './CandidateProfile.connect';

export const CandidateProfile = withScreenPersistence(
  CandidateProfileConnected,
  SCREEN_NAMES.candidate,
);
